import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import moment from "moment";
import faker from "faker";
import BankAccount, { BankAccountListResponse } from "../../models/bank-account";

const event = {
  title: "Access bank account opening new new",
  start_date: "2019-03-11",
  end_date: "2019-03-31",
  description: "The description of access bank account opening new new",
  status: "active",
  image: "cBy9UQSYdcS3.png",
  image_blob:
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQIAcQBxAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAMDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAj/xAAaEAEAAQUAAAAAAAAAAAAAAAAAAQIENIGx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCk7DEo32QDpn//2Q==",
  created_at: "2019-03-11 00:09:35",
  updated_at: "2019-03-11 13:02:47"
};

const arrayGen = count => Array.from(Array(count).keys());

/*
  Generated class for the DummyDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DummyDataProvider {
  constructor(public http: HttpClient) {}

  getEvents(type = "active", count = 20, delay = 1000) {
    const generateEvents = (type, count): ReadycashEvent[] => {
      switch (type) {
        case "active":
          return arrayGen(count).map((value, index) => ({
            ...event,
            id: index + 1,
            end_date: moment()
              .add(10 + Math.floor(Math.random() * 30), "days")
              .format("YYYY-MM-DD"),
            start_date: moment()
              .subtract(10 + Math.floor(Math.random() * 30), "days")
              .format("YYYY-MM-DD"),
            progress: Math.floor(Math.random() * 100),
            participants: Math.floor(Math.random() * 100)
          }));
        case "closed":
          return arrayGen(count).map((value, index) => ({
            ...event,
            id: index + 1,
            end_date: moment()
              .subtract(10 + Math.floor(Math.random() * 4), "days")
              .format("YYYY-MM-DD"),
            start_date: moment()
              .subtract(10 + Math.floor(Math.random() * 30), "days")
              .format("YYYY-MM-DD"),
            progress: Math.floor(Math.random() * 100),
            participants: Math.floor(Math.random() * 100),
            status: type,
            winners: arrayGen(3).map(() => ({
              name: faker.name.findName()
            }))
          }));
        default:
          return arrayGen(count).map((value, index) => ({
            ...event,
            id: index + 1
          }));
      }
    };
    return new Observable<ReadycashEvent[]>(observable => {
      setTimeout(() => {
        observable.next(generateEvents(type, count));
      }, delay);
      return () => {};
    });
  }

  getEvent(id) {}

  getAccountStatus(id): Observable<BankAccount> {
    return new Observable(observable => {
      setTimeout(
        () =>
          observable.next({
            id: Math.floor(Math.random() * 1000),
            full_name: faker.name.findName(),
            bank_name: "Fidelity Bank",
            reason: faker.lorem.sentence(),
          }),
        1000
      );
    });
  }

  getAccounts(): Observable<BankAccountListResponse> {
    return new Observable(observable => {
      const accounts = Array.from(Array(10).keys()).map(() => {
        return {
          id: Math.floor(Math.random() * 1000),
          full_name: faker.name.findName(),
          phone: faker.phone.phoneNumber(),
          bank_name: "Fidelity Bank",
          reason: faker.lorem.sentence(),
          status: Math.random() < 0.5 ? 0 : 1,
          account_no: Math.floor(Math.random() * 9999999999).toString(),
          bvn: Math.floor(Math.random() * 9999999999).toString(),
          deposit_amt: Math.floor(Math.random() * 99999).toString(),
        };
      });
      setTimeout(() => {
        observable.next({data: accounts, total: accounts.length});
      }, 1000);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/dummy-data/dummy-data.ts